import qs from "qs";
import request from "@/utils/request";

/* 行业分页列表 */
export function industryListApi(data) {
  return request({
    url: '/industry/page/list',
    method: 'post',
    headers: {'Content-Type': 'application/json;charset=UTF-8'},
    data: data
  })
}
/* 根据ID获取行业 */
export function industryIdApi(industryId) {
  return request({
    url: `industry/get/${industryId}`,
    method: 'get'
  })
}
/* 标签分页列表 */
export function labelListApi(data) {
  return request({
    url: '/label/page/list',
    method: 'post',
    headers: {'Content-Type': 'application/json;charset=UTF-8'},
    data: data
  })
}
/* 根据ID获取标签 */
export function labelIdApi(labelId) {
  return request({
    url: `label/get/${labelId}`,
    method: 'get'
  })
}
/* 查询树形结构分类 */
export function classListApi(params) {
  return request({
    url: '/query/tree/menu/category',
    method: 'get',
    params
  })
}
/* 根据ID获取分类详情 */
export function classIdApi(categoryId) {
  return request({
    url: `/query/menu/category`,
    method: 'get',
    params: {
      categoryId
    }
  })
}
/*
  根据ID获取分类详情
  2 软件
  4 渲染器
  5 包含
  6 版权
*/
export function mapListApi(params) {
  return request({
    url: `/common/get/dict/value/list/by/type`,
    method: 'get',
    params
  })
}
/* 新增资产 */
export function resourceAddApi(data) {
  return request({
    url: '/assets/v1/add',
    method: 'post',
    headers: {'Content-Type': 'application/json;charset=UTF-8'},
    data
  })
}
/* 查询资产详情 */
export function resourceDetailApi(id) {
  return request({
    url: '/assets/v1/get',
    method: 'get',
    params: { id }
  })
}
/* 查询资产详情(鉴权) */
export function resourceDetailTokenApi(id) {
  return request({
    url: '/assets/v1/get/by/auth',
    method: 'get',
    params: { id }
  })
}
/* 修改资产 */
export function resourceChangeApi(data) {
  return request({
    url: '/assets/v1/update',
    method: 'post',
    headers: {'Content-Type': 'application/json;charset=UTF-8'},
    data: data
  })
}
/* 查询我的积分列表 */
export function pointsListApi(data) {
  return request({
    url: '/points/page/list',
    method: 'post',
    headers: {'Content-Type': 'application/json;charset=UTF-8'},
    data: data
  })
}
/* 查询我的积分列表 */
export function mediaSetApi(params) {
  return request({
    url: '/sys/setting/get',
    method: 'get',
    headers: {'Content-Type': 'application/json;charset=UTF-8'},
    params: params
  })
}
export function downLoadApi(params) {
  return request({
    url: `/common/downloadNoAuth/file`,
    method: "post",
    responseType: "arraybuffer",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    params,
  });
}

export function downLoadUrlApi(params) {
  return request({
    url: `/common/get/downloadNoAuth/url`,
    method: "get",
    params,
  });
}

export function uplaodFileApi(data) {
  return request({
    url: `/common/uplaod/file`,
    method: "post",
    headers: { "Content-Type": "multipart/form-data" },
    data,
  });
}

export function uplaodImageWaterApi(data) {
  return request({
    url: `/common/uplaod/imageWater`,
    method: "post",
    headers: { "Content-Type": "multipart/form-data" },
    data,
  });
}

// 保存草稿箱接口
export function saveDraftBoxApi(params){
  return request({
    url: `/assets/get/list/selectDraftBin`,
    method: "post",
    headers: { "Content-Type": "multipart/form-data" },
    params
  })
}

// 我的资产模糊查询接口
export function assetsFuzzyQueryApi(params){
  return request({
    url: `/assets/get/list/page`,
    method: "get",
    params
  })
}

// 发布资产 删除资产接口
export function deleteAssetsApi(data){
  return request({
    url: '/common/delete/file',
    method: 'post',
    data
  })
}

// 发布资产 上传资产接口
export function addAssetsApi(data){
  return request({
    url: '/common/uplaod/file',
    method: 'post',
    headers: { "Content-Type": "multipart/form-data" },
    data
  })
}
